import { Tabs, TabsList, TabsTrigger } from "@/shared/ui/tabs";
import type { PropertyTab } from "./types";

interface PropertyDetailTabsNavProps {
  activeTab: PropertyTab;
  tabs: Array<{ value: PropertyTab; label: string }>;
  onTabChange: (tab: PropertyTab) => void;
}

export function PropertyDetailTabsNav({ activeTab, tabs, onTabChange }: PropertyDetailTabsNavProps) {
  return (
    <Tabs value={activeTab} onValueChange={(value) => onTabChange(value as PropertyTab)}>
      <TabsList className="w-full justify-start overflow-x-auto flex-nowrap bg-background/50 backdrop-blur-sm">
        {tabs.map((tab) => (
          <TabsTrigger
            key={tab.value}
            value={tab.value}
            className="whitespace-nowrap data-[state=active]:bg-primary/10 data-[state=active]:text-primary data-[state=active]:shadow-sm"
          >
            {tab.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
